import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import {host} from '../../function/api'

export const sectionOneSearch = createAsyncThunk(
    'section/one/search',
    async(data, thunkApi) => {
        try {
            const response = await axios({
                method: 'POST',
                url: `${host}sectionOne/search`,
                data: data,
                headers: {
                    'Accept': 'Application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`,
                    'xsrfHeaderName': "X-XSRF-TOKEN",
                    'withCredentials': true,
                }
            })

            return await response.data;

        } catch (error) {
            return thunkApi.rejectWithValue(error);
        }
    }
)

export const sectionTwoSearch = createAsyncThunk(
    'section/two/search',
    async(data, thunkApi) => {
        try {
            const response = await axios({
                method: 'POST',
                url: `${host}sectionTwo/search`,
                data: data,
                headers: {
                    'Accept': 'Application/json',
                    'xsrfHeaderName': "X-XSRF-TOKEN",
                    'withCredentials': true,
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }        
            })

            return await response.data;

        } catch (error) {
            return thunkApi.rejectWithValue(error);
        }
    }
)

export const sectionThreeSearch = createAsyncThunk(
    'section/three/search',
    async(data, thunkApi) => {
        try {
            const response = await axios({
                method: 'POST',
                url: `${host}sectionThree/search`,
                data: data,
                headers: {
                    'Accept': 'Application/json',
                    'xsrfHeaderName': "X-XSRF-TOKEN",
                    'withCredentials': true,
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }        
            })

            return await response.data;

        } catch (error) {
            return thunkApi.rejectWithValue(error);
        }
    }
)

const initialState= {
    loading: false,
    success: false,
    sections: [],
    partOne: [],
    partTwo: [],
    message: '',
    error: ''
}

const sectionSlice = createSlice({
    name: 'section',
    initialState,
    reducers: {

    },
    extraReducers: {
        [sectionOneSearch.fulfilled]: (state, action) => {
            state.loading = false;
            state.sections = action.payload.data
        },
        [sectionOneSearch.pending]: (state) => {
            state.loading = true;
        },
        [sectionOneSearch.rejected]: (state, {payload}) => {
            state.loading = false;
            if(payload.response.data.error){
                state.error = payload.response.data.error
            }
            if(payload.response.data.message) {
                state.message = payload.response.data.message
            }
        },
        [sectionTwoSearch.fulfilled]: (state, action) => {
            state.loading = false;
            state.partOne = action.payload.data
        },
        [sectionTwoSearch.pending]: (state) => {
            state.loading = true;
        },
        [sectionTwoSearch.rejected]: (state, {payload}) => {
            state.loading = false;
            console.log(payload)
            if(payload.response.data.error){
                state.error = payload.response.data.error
            }
            if(payload.response.data.message) {
                state.message = payload.response.data.message
            }
        },
        [sectionThreeSearch.fulfilled]: (state, action) => {
            state.loading = false;
            state.partTwo = action.payload.data
        },
        [sectionThreeSearch.pending]: (state) => {
            state.loading = true;
        },
        [sectionThreeSearch.rejected]: (state, {payload}) => {
            state.loading = false;
            if(payload.response.data.error){
                state.error = payload.response.data.error
            }
            if(payload.response.data.message) {
                state.message = payload.response.data.message
            }
        }
    }
})

export const {} = sectionSlice.actions;
export default sectionSlice.reducer; 